import type {Make} from './Make';

export type MakeVehicleType = {
  makes: Record<string, Make>;
};
